.label {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}
